// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { travelStatus, hotelStatus, invoiceApproval, invoiceApprovalLabels, perdiemPaymentNetSuiteStatusLabels } from "../utils/const"

export const getTravelStatusColor = (status) => {
    if (status === travelStatus.NEW) {
        return "#0AA1DD";
    }
    else if (status === travelStatus.INPROGRESS) {
        return "#F8CB2E";
    }
    else if (status === travelStatus.ONHOLD) {
        return "#cec0db"
    }
    else if (status === travelStatus.COMPLETED) {
        return "#76BA99"
    }
    else if (status === travelStatus.CANCELLED || status === "Canceled") {
        return "#92A9BD"
    }
    else if (status === travelStatus.EXTENDED) {
        return "#6101EE"
    }
    else {
        return "#FFF"
    }
}

export const getInvoiceStatusLabelColors = (status) => {
    if (status === invoiceApprovalLabels.PENDING) {
        return "#F8CB2E";
    }
    else if (status === invoiceApprovalLabels.APPROVED) {
        return "#76BA99";
    }
    else if (status === invoiceApprovalLabels.REJECTED) {
        return "#ED8E8E"
    }
    else if (status === invoiceApprovalLabels.PUSHED) {
        return "#76BA99"
    }
    else {
        return "#FFF"
    }
}

export const getTravelStatusFontColor = (status) => {
    if (status === travelStatus.NEW) {
        return "#FFF";
    }
    else if (status === travelStatus.INPROGRESS) {
        return "#FFF";
    }
    else if (status === travelStatus.ONHOLD) {
        return "#FFF"
    }
    else if (status === travelStatus.COMPLETED) {
        return "#FFF"
    }
    else if (status === travelStatus.CANCELLED || status === "Canceled") {
        return "#FFF"
    }
    else if (status === travelStatus.EXTENDED) {
        return "#FFF"
    }
    else {
        return "#000"
    }
}

export const getHotelStatusColor = (status) => {
    if (status === hotelStatus.TENTATIVE) {
        return "#F8CB2E";
    }
    else if (status === hotelStatus.ONHOLD) {
        return "#cec0db"
    }
    else if (status === hotelStatus.CONFIRMED) {
        return "#0AA1DD"
    }
    else if (status === hotelStatus.CANCELLED || status === "Canceled") {
        return "#92A9BD"
    }
    else {
        return "#FFF"
    }
}

export const getHotelStatusFontColor = (status) => {
    if (status === hotelStatus.TENTATIVE) {
        return "#FFF";
    }
    else if (status === hotelStatus.ONHOLD) {
        return "#FFF"
    }
    else if (status === hotelStatus.CONFIRMED) {
        return "#FFF"
    }
    else if (status === hotelStatus.CANCELLED || status === "Canceled") {
        return "#FFF"
    }
    else {
        return "#000"
    }
}

export const getVisaStatusColor = (isActive) => {
    if (isActive) {
        return "#76BA99"
    }
    else {
        return "#F37878"
    }
}

export const getTravelDocumentStatusColor = (isActive) => {
    if (isActive) {
        return "#76BA99"
    }
    else {
        return "#F37878"
    }
}

export const getVisaTimeColor = (years, months, days) => {
    if (years > 0) {
        return "#0AA1DD";
    }
    if (months > 0) {
        return "#cec0db"
    }
    if (days >= 0) {
        return "#F8CB2E";
    }
    return "#F37878"
}

export const getHrApprovalStatusInfo = (status) => {
    if (status === invoiceApproval.PENDING) {
        return [invoiceApprovalLabels.PENDING, "#F8CB2E", "#FFF"];
    }
    else if (status === invoiceApproval.REJECTED_BY_TRAVEL) {
        return [invoiceApprovalLabels.REJECTED, "#ED8E8E", "#FFF"]
    }
    else if (status === invoiceApproval.COMPLETE || status === invoiceApproval.ACCEPTED_BY_TRAVEL || status === invoiceApproval.ACCEPTED_BY_FINANCE || status === invoiceApproval.REJECTED_BY_FINANCE) {
        return [invoiceApprovalLabels.APPROVED, "#76BA99", "#FFF"]
    }
    else {
        return ["N/A", "#FFF", "#000"]
    }
}

export const getFinanceApprovalStatusInfo = (status) => {
    if (status === invoiceApproval.PENDING || status === invoiceApproval.REJECTED_BY_TRAVEL || status === invoiceApproval.ACCEPTED_BY_TRAVEL) {
        return [invoiceApprovalLabels.PENDING, "#F8CB2E", "#FFF"];
    }
    else if (status === invoiceApproval.REJECTED_BY_FINANCE) {
        return [invoiceApprovalLabels.REJECTED, "#ED8E8E", "#FFF"]
    }
    else if (status === invoiceApproval.COMPLETE || invoiceApproval.ACCEPTED_BY_FINANCE) {
        return [invoiceApprovalLabels.APPROVED, "#76BA99", "#FFF"]
    }
    else {
        return ["N/A", "#FFF", "#000"]
    }
}

export const getNetSuiteStatusInfo = (status) => {
    if (status === invoiceApproval.COMPLETE) {
        return [invoiceApprovalLabels.PUSHED, "#76BA99", "#FFF"]
    }
    else{
        return [invoiceApprovalLabels.PENDING, "#F8CB2E", "#FFF"];
    }
}

export const getPerdiemPaymentNetSuiteStatusInfo = (status) => {
    if (status === perdiemPaymentNetSuiteStatusLabels.PUSHED) {
        return "#76BA99";
    }
    else if(status === perdiemPaymentNetSuiteStatusLabels.PENDING){
        return "#F8CB2E";
    }
    else{
        return "#FFF"
    }
}

export const getFinanceApprovalStatusColor = (status) => {
    if (status === invoiceApproval.PENDING) {
        return "#F8CB2E";
    }
    else if (status === invoiceApproval.COMPLETE || status === invoiceApproval.ACCEPTED_BY_FINANCE) {
        return "#0AA1DD"
    }
    else if (status === invoiceApproval.REJECTED_BY_FINANCE) {
        return "#92A9BD"
    }
    else {
        return "#FFF"
    }
}

export const getFinanceApprovalStatusFontColor = (status) => {
    if (status === invoiceApproval.PENDING) {
        return "#FFF"
    }
    else if (status === invoiceApproval.CONFIRMED || status === invoiceApproval.APPROVED_BY_TRAVEL) {
        return "#FFF"
    }
    else if (status === invoiceApproval.REJECTED_BY_TRAVEL) {
        return "#FFF"
    }
    else {
        return "#FFF"
    }
}